/* Judge.me carousel — mobile auto-advance.
   Clicks the widget's own (hidden) next arrow so its slide logic,
   looping clones, and transitions stay intact.
   Pauses while the user is interacting, while the carousel is
   off-screen, and while the tab is hidden. */
(function () {
  var INTERVAL_MS = 3500;   // time between advances
  var RESUME_MS = 8000;     // idle time after a touch before resuming
  var mq = window.matchMedia('(max-width: 749px)');
  var paused = false;
  var resumeTimer = null;

  function carousel() {
    return document.querySelector('.jdgm-cards-carousel');
  }

  function nextArrow() {
    var c = carousel();
    if (!c) return null;
    var arrows = c.querySelectorAll('.jdgm-content .jdgm-arrow');
    return arrows.length ? arrows[arrows.length - 1] : null;
  }

  function tick() {
    if (!mq.matches || paused || document.hidden) return;
    var c = carousel();
    if (!c) return;
    var r = c.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return; // off-screen
    var btn = nextArrow();
    if (btn) btn.click();
  }

  function bump(e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.jdgm-cards-carousel')) return;
    paused = true;
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () { paused = false; }, RESUME_MS);
  }

  document.addEventListener('touchstart', bump, { passive: true });
  document.addEventListener('pointerdown', bump, { passive: true });

  setInterval(tick, INTERVAL_MS);
})();
